var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlusIcon = function SvgPlusIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#717680",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.667,
    d: "M9.166 5.833V12.5M5.833 9.167H12.5m5 0a8.333 8.333 0 1 1-16.667 0 8.333 8.333 0 0 1 16.667 0"
  })));
};
export { SvgPlusIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAxOSAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuMTY2MzQgNS44MzMzMVYxMi41TTUuODMzMDEgOS4xNjY2NUgxMi40OTk3TTE3LjQ5OTcgOS4xNjY2NUMxNy40OTk3IDEzLjc2OSAxMy43Njg3IDE3LjUgOS4xNjYzNCAxNy41QzQuNTYzOTcgMTcuNSAwLjgzMzAwOCAxMy43NjkgMC44MzMwMDggOS4xNjY2NUMwLjgzMzAwOCA0LjU2NDI3IDQuNTYzOTcgMC44MzMzMTMgOS4xNjYzNCAwLjgzMzMxM0MxMy43Njg3IDAuODMzMzEzIDE3LjQ5OTcgNC41NjQyNyAxNy40OTk3IDkuMTY2NjVaIiBzdHJva2U9IiM3MTc2ODAiIHN0cm9rZS13aWR0aD0iMS42NjY2NyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";